/* eslint-disable max-len */
export const DUTCH_TRANSLATIONS_PAGES = {
  'LANDINGS-PAGE': {
    TITLE: 'Upload je pasfoto voor een nieuwe kaart',
    INFO:
      'Vul hieronder je gegevens in om je nieuwe pasfoto bij NS aan te leveren.',
    CARDNUMBER: 'Kaartnummer',
    REFNUMBER: 'Referentienummer',
    ERROR: {
      VALIDATION:
        'Je kaartnummer/referentienummer komt niet in ons systeem voor. Controleer je gegevens en verstuur het formulier opnieuw.',
      CARDNUMBER: 'Kaartnummer is niet in het juiste formaat.',
      REFNUMBER: 'Referentienummer is niet in het juiste formaat.'
    },
    TOOLTIP: {
      CARDNUMBER:
        'Het OV-chipkaartnummmer vind je linksonder op je OV-chipkaart. Het bestaat uit 16 cijfers.',
      REFNUMBER:
        'Het referentienummer staat vermeld in de e-mail of brief die je van NS hebt ontvangen.'
    }
  },
  'UPLOAD-PAGE': {
    TITLE: 'Upload je nieuwe pasfoto',
    INFO: 'Hieronder kun je een nieuwe pasfoto kiezen.',
    'IMAGE-CHOOSE':
      'Wil je liever een andere foto? Klik dan hiernaast op "Kies foto"',
    'IMAGE-VALID':
      'Je pasfoto is goedgekeurd. Ben je tevreden met het resultaat? Dan kun je dit formulier verzenden.',
    'IMAGE-PERMISSION':
      'Ik geef toestemming aan NS om mijn pasfoto te bewaren voor de duur van mijn contract voor het maken van een nieuwe kaart.',
    'IMAGE-REQUIREMENTS-INFO':
      'Deze pasfoto wordt geprint op je nieuwe kaart. Je dient goed herkenbaar op de foto te staan. Dat betekent:',
    'IMAGE-REQUIREMENTS': [
      'Het is alleen een foto van je gezicht',
      'Je kijkt recht in de camera',
      'Je gezicht is onbedekt',
      'Je hebt geen zonnebril op'
    ],
    ERROR: {
      'IMAGE-INVALID-DEFAULT': 'Je dient goed herkenbaar op de foto te staan.',
      'IMAGE-INVALID-TITLE': 'Je pasfoto is afgekeurd om de volgende redenen:',
      'PF-3': 'Geen gezicht gevonden',
      LEFT_EYE_VALID_LIKELIHOOD: 'Je bent niet goed zichtbaar op de foto'
    }
  },
  'THANKS-PAGE': {
    TITLE: 'Bedankt voor je aanvraag',
    INFO:
      'Je gegevens zijn succesvol opgeslagen en worden verwerkt in ons systeem.'
  }
};
